import { useEffect, useState } from "react";
import axios from "axios";
import { API, FALLBACK_ARTICLES, FALLBACK_TAX_SEASON } from "@/lib/content";

export const useSiteContent = () => {
  const [data, setData] = useState({
    tax_season: FALLBACK_TAX_SEASON,
    articles: FALLBACK_ARTICLES,
    loaded: false,
  });
  useEffect(() => {
    axios
      .get(`${API}/content`)
      .then((r) => setData({ ...r.data, loaded: true }))
      .catch(() => setData((d) => ({ ...d, loaded: true })));
  }, []);
  return data;
};
